/**
 * @generated SignedSource<<520c7c87aa572342cba14a48f0779a62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly$data = {
  readonly weeklyTeamSchedule: {
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentList_teamSchedule" | "WidgetTeamScheduleContentSectionHeader_teamSchedule">;
  };
  readonly " $fragmentType": "WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly";
};
export type WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly$key = {
  readonly " $data"?: WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "weeklyTeamSchedule",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamScheduleContentList_teamSchedule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamScheduleContentSectionHeader_teamSchedule"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTeamScheduleContentWeekly",
  "abstractKey": null
};

(node as any).hash = "efffbf27189cb28e20fd29fc611a3b95";

export default node;
